var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPareto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "46px",
    viewBox: "0 0 50 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loading/Pareto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.62219557%",
    y1: "7.98611111%",
    x2: "72.9278826%",
    y2: "75.2882106%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626263",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F31",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Data->-Loading-Widgets",
    transform: "translate(-380.000000, -801.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(22.000000, 654.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,183.742424 C407.552285,183.742424 408,184.190139 408,184.742424 L408,191.833333 C408,192.385618 407.552285,192.833333 407,192.833333 L399.666667,192.833333 L399.666667,183.742424 L407,183.742424 Z M398.666667,171.621212 C399.218951,171.621212 399.666667,172.068927 399.666667,172.621212 L399.666667,179.712121 C399.666667,180.264406 399.218951,180.712121 398.666667,180.712121 L383,180.712121 L383,171.621212 L398.666667,171.621212 Z M382,159.5 C382.552285,159.5 383,159.947715 383,160.5 L383,167.590909 C383,168.143194 382.552285,168.590909 382,168.590909 L358,168.590909 L358,159.5 L382,159.5 Z M407,147 C407.552285,147 408,147.447715 408,148 L408,155.090909 C408,155.643194 407.552285,156.090909 407,156.090909 L358,156.090909 L358,147 L407,147 Z",
    id: "Loading/Pareto"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "0.5s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPareto);
export default __webpack_public_path__ + "static/media/icon-pareto.9f91ad6d1e23b0ada71fcc6ca5caab69.svg";
export { ForwardRef as ReactComponent };